<template>
    <section>
        <div class="row justify-content-center">
            <div class="col col-lg-10 px-5">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb mt-5 mb-0 py-0">
                        <li class="breadcrumb-item h3 font-weight-bold active mb-0 text-uppercase" aria-current="page">
                            Forum
                        </li>
                    </ul>
                    <ul class="breadcrumb forum py-0">
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'index' }">
                                Home
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/index' }">
                                Forum
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/subject', params: {id: category.gradeSubject.gradeID} }">
                                {{ category.gradeSubject.grade.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/category', params: {id: category.gradeSubjectID} }">
                                {{ category.gradeSubject.subject.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/thread/index', params: {id: category.id} }">
                                {{ category.title }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium active" aria-current="page">
                            Add
                        </li>
                    </ul>
                </nav>
                <div class="row mb-3">
                    <div class="col">
                        <form v-on:submit.prevent="save">
                            <div class="card shadow-sm mb-3 border-0">
                                <div class="card-body">
                                    <div class="row mb-3">
                                        <div class="col">
                                            <h3 class="font-weight-bold">Buat Thread</h3>
                                            <h4 class="font-weight-medium mb-0">
                                                {{ profile.name }}
                                                <small class="text-muted">{{ listRoles(profile) }}</small>
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col">
                                            <label class="font-weight-bold">Judul</label>
                                            <input v-model="form.title" class="form-control form-control-sm" placeholder="Judul..." required />
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col">
                                            <label class="font-weight-bold">Isi</label>
					    <p> *Dimohon untuk meng-upload gambar yang tidak lebih dari 256kb</p>
                                            <tinymce id="editor" v-model="form.content" v-bind:other_options="tinyMCEOptions"></tinymce>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-auto ml-auto">
                                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                                Post
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import tinymce from 'vue-tinymce-editor';
    import { tinyMCEOptions, employeeRoles, additionalRoles } from '@/params.js';
    import { mapState } from 'vuex';

    export default {
        name: "ForumThreadAdd",
        computed: mapState([
            'profile'
        ]),
        components: {
            tinymce
        },
        methods: {
            save() {
	    if (this.form.content.length < 400000  ) {
                this.axios.post(process.env.API_URL + '/thread', Object.assign({}, this.form, {forumSubcategoryID: this.category.id})).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$store.dispatch('setProfile', {requestOptions: {meta: {throwError: false}}});
                        this.$router.push({name: 'forum/thread/index', params: {id: this.category.id}});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
		}
	    
	    else {
		alert("Gambar yang diupload harus dibawah 256Kb ");
	    }
            },
            listRelations(relations) {
                return typeof relations !== typeof undefined ? relations.map(object => object.name).join(', ') : '';
            },
            listRoles(user) {
                var roles = [];
                for (var i in additionalRoles) {
                    if (user['is' + additionalRoles[i].id]) {
                        roles.push(additionalRoles[i].id);
                    }
                }
                if (user.isEmployee) {
                    for (var i in employeeRoles) {
                        if (user.employee['is' + employeeRoles[i].id]) {
                            roles.push(employeeRoles[i].id);
                        }
                    }
                }
                return this.listRelations(this.roles.filter(object => roles.includes(object.id)));
            },
            roleElligible() {
                return this.profile.isAdmin || (this.profile.isStudent && this.profile.student.remainingVouchers > 0) || (this.profile.isEmployee && (this.profile.employee.isDirector || this.profile.employee.isManager));
            }
        },
        data() {
            return {
                form: {
                    title: '',
                    content: ''
                },
                category: {gradeSubject: {grade: {}, subject: {}}},
                roles: [],
                tinyMCEOptions: tinyMCEOptions
            };
        },
        created() {
            this.roles = employeeRoles.concat(additionalRoles);
            this.axios.get(process.env.API_URL + '/forum-subcategory/' + this.$route.params.id).then(response => {
                this.category = response.data.data;

                if (!this.roleElligible()) {
                    this.$router.replace({name: 'error', params: {code: 403, message: 'User Not Authorize'}});
                }

                document.title = 'Forum - Add Thread ' + this.category.gradeSubject.grade.name + ' ' + this.category.gradeSubject.subject.name + ' ' + this.category.title + ' | ' + process.env.APP_NAME;
            });

        }
    };
</script>


// WEBPACK FOOTER //
// src/components/forum/thread/Add.vue